<template>
    <layout-gestao v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form
                    autocomplete="off"
                    method="post"
                    :disabled="isLoading"
                    data-vv-scope="form"
                    @submit.prevent="onBeforeSaveItem"
                    @keyup.enter="() => {}">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div :class="colForm">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialInput
                                            class="city-form-group city-bg"
                                            id="input-name"
                                            name="name"
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            v-model.trim="form.name"
                                            v-validate="'required|max:100'"
                                            :inputClasses="[{'is-invalid': fnHasError(`name`)}]"
                                            :error=" fnFirstError(`name`)"
                                            :helpText="`${pageID}.help.name`">
                                            {{ $t(`${pageID}.model.name`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialInput
                                            class="city-form-group city-bg"
                                            id="input-description"
                                            name="description"
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            v-model.trim="form.description"
                                            v-validate="'max:250'"
                                            :inputClasses="[{'is-invalid': fnHasError(`description`)}]"
                                            :error=" fnFirstError(`description`)"
                                            :helpText="`${pageID}.help.description`">
                                            {{ $t(`${pageID}.model.description`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            class="city-form-group city-bg"
                                            id="input-roles"
                                            name="roles"
                                            :disabled="readonlyFormItem"
                                            v-model.trim="form.category.roles"
                                            :filterable="false"
                                            :options="lists.roles"
                                            :reduceObject="true"
                                            :multiple="true"
                                            label="name"
                                            v-validate="''"
                                            :inputClasses="[{'is-invalid': fnHasError('roles') }]"
                                            :error="fnFirstError('roles')"
                                            :helpText="`${pageID}.help.roles`" >
                                            {{ $t(`${pageID}.model.roles`) }}
                                        </MaterialSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4" v-if="!isSingleLocale">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            :disabled="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-locale"
                                            label="name"
                                            name="locale"
                                            :options="getLocale"
                                            :reduce="option => option.code"
                                            v-model.trim="form.locale"
                                            v-validate="{required:form.locale!=null}"
                                            :inputClasses="[{'is-invalid': fnHasError('locale') }]"
                                            :error=" fnFirstError('locale')"
                                            helpText="Língua traduzida"
                                        >
                                            Língua
                                        </MaterialSelect>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            :disabled="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-category_id"
                                            label="name"
                                            name="category_id"
                                            :options="lists.availabelTranslations"
                                            :reduce="option => option.category_id"
                                            v-model.trim="form.category_id"
                                            v-validate="{}"
                                            :inputClasses="[{'is-invalid': fnHasError('category_id') }]"
                                            :error="fnFirstError('category_id')"
                                            helpText="Vincular a tradução da categoria selecionada"
                                        >
                                            Tradução da categoria
                                        </MaterialSelect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="onBeforeSaveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"/>
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        data() {
            return {
                pageID: 'news_categories',
                form: {
                    id: null,
                    name: null,
                    slug: null,
                    description: null,
                    locale: null,
                    news_category_id: null,
                    category: {
                        roles: [],
                        translations: [],
                    }
                },
                lists: {
                    translations: [],
                    roles: [],
                }
            }
        },
        mounted() {
            this.form.locale = this.defaultLocale ? this.defaultLocale.code : null;

            if(!this.hasId) {
                this.loadListsOptions();
            }
        },
        computed: {
            colForm: function() {
                return this.isSingleLocale ? 'col-sm-12' : 'col-sm-8'
            }
        },
        methods: {
            loadListsOptions() {
                let params = {
                    locale: this.form.locale,
                };

                this.loadLists(this.urlLists(), params)
                .then( res => {
                    if(!res) return;
                });
            },
            callbackLoadItem: function () {
                this.loadListsOptions();
            },
            onBeforeSaveItem() {
                this.saveItem(null);
            },
        },
        watch: {
            'form.locale': function(newValue, oldValue){
                const searchTranslation = this.form.category.translations.find(translation => {
                    return translation.locale == newValue && translation.id !=this.form.id
                });
                if(searchTranslation) this.form.news_category_id = '';

                if(newValue != oldValue && oldValue) {
                    this.loadListsOptions();
                }
            }
        },
    }
</script>
